<template>
  <div
    class="tw:flex tw:justify-between tw:items-center tw:hover:bg-default-000 tw:cursor-pointer tw:transition-all tw:duration-200 tw:ease-in-out"
    :data-item-id="customerId"
    @click="handleViewProfile"
  >
    <div class="tw:flex tw:items-center tw:p-3 tw:gap-2">
      <div>
        <p class="tw:body-2 tw:text-black">{{ firstName }} {{ lastName }}</p>
        <p class="tw:caption tw:text-default-700">{{ email }}</p>
      </div>
    </div>

    <EdroneButton class="tw:mr-3" type="outline" size="small" @click="handleViewProfile">
      {{ trans._menu.searchBar.viewProfile }}
    </EdroneButton>
  </div>
</template>

<script setup lang="ts">
import EdroneButton from "edrone-components/EdroneButton.vue";
import { sendCustomEventToGA } from "vue-app/plugins/edroneGtag";

interface Props {
  customerId: number;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
}

interface Emits {
  viewProfile: [customerId: number];
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const handleViewProfile = () => {
  emit("viewProfile", props.customerId);
  sendCustomEventToGA("search_bar_view_profile_click");
};
</script>
